// extracted by mini-css-extract-plugin
export default {"block":"block___QNER2","country_info":"country_info___MoWxw"};